import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import { isEmpty } from '@/utils';
import { getShopBrands } from '../../api';
export default {
  name: 'shop_brands_config',
  components: {
    draggable: draggable
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object
  },
  data: function data() {
    return {
      bid: '',
      list: [],
      rules: {
        name: [{
          required: true,
          message: '组件名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '标题字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        category_id: [{
          required: true,
          message: '请选择实体菜单',
          trigger: 'change'
        }],
        brandList: [{
          required: true,
          message: '品牌不可为空',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    // 切换实体数据源 清空原有选择数据
    changeCategory: function changeCategory(category_id) {
      this.value.config.brandList = [];
      this.bid = '';
      category_id && this.loadData();
    },
    // 添加
    addBrand: function addBrand() {
      var _this = this;
      if (!this.bid) {
        this.$message.error('请先选择一个品牌');
        return;
      }
      var data = this.list.find(function (i) {
        return i.id === _this.bid;
      });
      var id = data.id,
        brand_name = data.brand_name,
        path = data.path;
      this.value.config.brandList.push({
        id: id,
        brand_name: brand_name,
        brand_logo: path
      });
      this.bid = '';
      this.$refs.form.validateField('brandList');
    },
    // 删除
    deleteBrand: function deleteBrand(index) {
      this.value.config.brandList.splice(index, 1);
    },
    // 获取实体品牌列表
    loadData: function loadData() {
      var _this2 = this;
      getShopBrands({
        category_id: this.value.config.category_id
      }, this.info.module).then(function (res) {
        _this2.list = res.data;
      });
    }
  },
  created: function created() {
    if (isEmpty(this.value.config)) {
      this.$set(this.value, 'config', {
        name: '优选品牌',
        category_id: '',
        //实体菜单数据源
        bids: [],
        // 后端需要用的选择的品牌ID数组
        brandList: [] // 用于排序 & 回显 & 中心区域展示的数据
      });
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
    this.value.config.category_id && this.loadData();
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['entity', 'new_entity'].includes(i.type);
      });
    }
  },
  watch: {
    'value.config.brandList': function valueConfigBrandList(brandList) {
      this.value.config.bids = brandList === null || brandList === void 0 ? void 0 : brandList.map(function (i) {
        return i.id;
      });
    }
  }
};